export default __webpack_public_path__ + "slices/main/assets/public/fonts/tiempos/tiempos-headline-semibold.69e9f00a360ca22965a408f6fc338d65.woff2";